/**
 * IndexedDB 按登录用户隔离：库名带 userId，旧全局库登录时丢弃（不迁移）。
 *
 * 用法：
 * - open 前：ownerScopedIndexedDbName('funding_image_storage')
 * - 未 bind：返回 null，调用方应拒绝读写
 * - 登录 bind：dropLegacyUnscopedIndexedDatabases()
 * - 换号 / 退出：close 各模块缓存的 dbInstance
 */
import { getIpeUserLocalOwnerId } from '@/utils/ipeUserLocalState';

/** 历史上未按用户隔离的库名（登录时 deleteDatabase，绝不迁入新库） */
export const LEGACY_UNSCOPED_INDEXED_DB_NAMES = [
  'funding_image_storage',
  'funding_file_storage',
  'funding_text_storage',
];

/**
 * @param {string} baseName 逻辑库名，如 funding_image_storage
 * @returns {string|null} 当前用户作用域库名；未绑定返回 null
 */
export function ownerScopedIndexedDbName(baseName) {
  const owner = getIpeUserLocalOwnerId();
  const base = String(baseName || '').trim();
  if (!owner || !base) return null;
  return `${base}__u__${owner}`;
}

/**
 * 丢弃未隔离的旧全局 IndexedDB（只删不迁）。
 * 可安全重复调用；不影响 `__u__{userId}` 作用域库。
 */
export function dropLegacyUnscopedIndexedDatabases() {
  if (typeof indexedDB === 'undefined' || typeof indexedDB.deleteDatabase !== 'function') {
    return;
  }
  LEGACY_UNSCOPED_INDEXED_DB_NAMES.forEach((name) => {
    try {
      indexedDB.deleteDatabase(name);
    } catch (e) {
      console.warn('[ipeUserIndexedDb] 删除旧全局库失败:', name, e);
    }
  });
}
